<template>
  <v-card
    :color="value ? 'white' : 'grey lighten-5'"
    :elevation="value ? 12 : 0"
    class="pa-2"
    outlined
    tile
  >
    <v-card
      flat
      outlined
      tile
    >
      <div
        :class="value && 'grey lighten-4'"
        class="pa-6 pb-12 mb-8"
      >
        <base-title
          :title="title"
          class="text-uppercase"
          space="1"
        />

        <base-subtitle
          :title="subtitle"
          space="4"
        />

        <div class="d-flex align-center justify-center">
          <base-heading
            mobile-size="display-2"
            space="0"
            tag="h3"
          >
            <h1>
              <sup><small>$</small></sup>
              <animated-number
                :value="totalSavings"
                :format-value="numberWithCommas"
                :duration="1000"
              />
            </h1>
          </base-heading>

          <div
            v-show="isMonthly"
            class="text-left ml-4 body-2 font-weight-bold mt-1 text-uppercase text-"
          >
            Per
            <base-divider
              align="left"
              color="primary"
              space="0"
            />
            Year
          </div>
        </div>
      </div>

      <div class="mb-8" />

      <div class="pb-12">
        <div class="px-8 mb-12">
          <template v-for="(feature, i) in features">
            <div
              :key="feature"
              class="my-3"
              v-text="feature"
            />

            <v-divider
              v-if="i + 1 < features.length"
              :key="`divider-${i}`"
            />
          </template>
        </div>
        <base-btn
          v-visible="link"
          :to="{ name: 'Loan Application' }"
          :color="value ? 'primary' : 'accent'"
          :outlined="!value"
          width="196"
        >
          Get Started
        </base-btn>
      </div>
    </v-card>
  </v-card>
</template>

<script>
  import AnimatedNumber from 'animated-number-vue'
  export default {
    name: 'LoanComparisonCard',
    components: {
      AnimatedNumber,
    },

    provide: {
      heading: { align: 'center' },
    },

    props: {
      totalSavings: Number,
      link: Boolean,
      subtitle: String,
      title: String,
      value: Boolean,
      features: Array,
      isMonthly: Boolean,
    },
    data: () => ({
      search: null,
    }),
    watch: {
      search (val) {
        if (!val) {
          return
        }
        this.debounce()
      },
    },
    methods: {
      formatToPrice (value) {
        return value
      },
      numberWithCommas (x) {
        return x.toFixed().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },

      debounce (x) {
        clearTimeout(this._timerId)

        this._timerId = setTimeout(() => {
          this.numberWithCommas(x)
        }, 500)
      },
    },
  }
</script>
